import { render, staticRenderFns } from "./AdminServiceForm.vue?vue&type=template&id=1afe6d90&scoped=true&"
import script from "./AdminServiceForm.vue?vue&type=script&lang=js&"
export * from "./AdminServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./AdminServiceForm.vue?vue&type=style&index=0&id=1afe6d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe6d90",
  null
  
)

export default component.exports